declare global {
    interface Window {
        grecaptcha: any
    }
}

export default class reCAPTCHA {
    siteKey: string
    action: string
    scriptLoaded: Promise<void>

    constructor(siteKey: string, action: string) {
        this.scriptLoaded = loadReCaptcha(siteKey)
        this.siteKey = siteKey
        this.action = action
    }

    async getToken(): Promise<string> {
        await this.scriptLoaded
        await new Promise<void>((resolve) => window.grecaptcha.ready(resolve))
        return window.grecaptcha.execute(this.siteKey, { action: this.action })
    }
}

let scriptLoaded: Promise<void> | undefined

const loadReCaptcha = (siteKey: string): Promise<void> => {
    if (!scriptLoaded) {
        scriptLoaded = new Promise((resolve, reject) => {
            const script = document.createElement("script")
            script.src = `https://www.recaptcha.net/recaptcha/api.js?render=${siteKey}`
            script.onload = () => resolve()
            script.onerror = () => reject(new Error("reCAPTCHA failed to load"))
            document.body.appendChild(script)
        })
        // The script can fail before a form submits.
        scriptLoaded.catch(() => {})
    }
    return scriptLoaded
}
